<mat-card class="settingsBody">
    <!-- Heading -->
    <div class="settings-heading">
        <span>Domain Management</span>
    </div>
    <div class="select-heading">Manage and view your company domains</div>
    <div>
        <div class="'padding-24'">
            <!-- Page Inputs -->
            <div class="padding-16-top-bottom">
                <!-- Search Field -->
                <mat-form-field fluid appearance="outline" class="example-full-width">
                    <mat-label>Find Domain</mat-label>
                    <input
                        matInput
                        [(ngModel)]="domainSearchTerm"
                        class="search-field"
                        #domainSearchBox
                        (ngModelChange)="filterDomains()"
                        [ngModelOptions]="{ standalone: true }"
                    />
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>

                <div class="employee-add-button-area float-right">
                    <button type="button" mat-raised-button (click)="addDomain()">
                        <i class="fal fa-plus-square" A></i>
                        ADD DOMAIN
                    </button>
                </div>
            </div>
            <!-- Domain Table -->
            <div style="min-height: 450px">
                <kendo-grid
                    id="domainGrid"
                    height="684"
                    [data]="gridView"
                    [skip]="skip"
                    [sortable]="sortable"
                    [sort]="domainEntrySort"
                    [pageable]="pageable"
                    [pageSize]="pageSize"
                    [scrollable]="scrollable"
                    [loading]="loading"
                    (sortChange)="sortChange($event)"
                    (pageChange)="pageChange($event)"
                    (dataStateChange)="onStateChange($event)"
                    (edit)="editHandler($event)"
                    (cancel)="cancelHandler($event)"
                    (save)="saveHandler($event)"
                    (remove)="removeHandler($event)"
                    (add)="addHandler($event)"
                >
                    <ng-template kendoGridNoRecordsTemplate>
                        <div class="no-data-message-area" *ngIf="noDomains">
                            <no-data-screen [noDataType]="noDataType"> </no-data-screen>
                        </div>
                    </ng-template>

                    <!-- Domain -->
                    <kendo-grid-column
                        field="domain"
                        title="Domain"
                        [headerClass]="'header'"
                        [headerStyle]="headerStyle"
                    >
                        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                            {{ dataItem.domain }}
                        </ng-template>
                    </kendo-grid-column>

                    <!-- Command -->
                    <kendo-grid-command-column
                        title=""
                        [headClass]="'header'"
                        [headerStyle]="headerStyle"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                    >
                        <ng-template kendoGridCellTemplate let-isNew="isNew">
                            <button
                                type="button"
                                class="btn-w-100"
                                mat-stroked-button
                                kendoGridEditCommand
                            >
                                Edit
                            </button>
                            <button
                                type="button"
                                class="btn-w-100 second-button"
                                mat-stroked-button
                                color="warn"
                                kendoGridRemoveCommand
                                outlined
                            >
                                Remove
                            </button>
                            <button
                                type="button"
                                class="btn-w-100 button-green"
                                mat-stroked-button
                                kendoGridSaveCommand
                                [disabled]="formGroup?.invalid"
                            >
                                {{ isNew ? 'Add' : 'Update' }}
                            </button>
                            <button
                                type="button"
                                class="btn-w-100 second-button"
                                mat-stroked-button
                                kendoGridCancelCommand
                                outlined
                            >
                                {{ isNew ? 'Discard changes' : 'Cancel' }}
                            </button>
                        </ng-template>
                    </kendo-grid-command-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</mat-card>
